import React, { useMemo } from 'react';
import { BasePieChart } from 'components/atoms/charts';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import Empty from './empty';
import LegendList from './legend-list';

import type { IPieChartData } from 'components/atoms/charts/types';

interface IProps {
  title: string;
  data: IPieChartData[];
  compact?: boolean;
}

const SmsMetricsPieChart: React.FC<IProps> = (props) => {
  const { title, data, compact } = props;

  const { t } = useTranslation();

  const hasData = !!data.length;
  const totalValue = useMemo(() => {
    return data.reduce((sum, d) => sum + d.value, 0);
  }, [data]);

  const emptyChart = [
    {
      name: t('labels.noData'),
      value: 100,
      color: '#cccad7',
    },
  ];

  return (
    <div className={s.wrapper}>
      <div className={s.title}>{title}</div>
      <div className={s.body}>
        <div className={s.left}>
          {hasData ? (
            <LegendList total={totalValue} data={data} compact={compact} />
          ) : (
            <Empty />
          )}
        </div>
        <div className={s.right}>
          <BasePieChart
            data={hasData ? data : emptyChart}
            total={{
              value: hasData ? totalValue : '-/-',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SmsMetricsPieChart;
